<div class="w-20">
  <button
    class="app__btn--primary bg-[#ebf0fa] rounded-3xl text-k-blue leading-3 min-w-fit w-[63px] p-0 h-7 font-semibold sm:py-1"
    mat-button
    #menuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="menu"
    >
    <span class="material-icons search-icon text-sm font-semibold"> add </span>
    <span class="text-xs font-semibold"> Add </span>
  </button>
</div>

<mat-menu #menu="matMenu" class="rounded-lg max-w-[500px] w-[440px] h-[320px] mt-6 p-0" (closed)="onMenuClosed()">
  <div>
    <div class="flex justify-between items-center p-4 shadow-md">
      <p class="m-0">Add new connection</p>
      <span class="material-icons search-icon text-k-black text-sm font-bold" (click)="(menu)"> close </span>
    </div>
    <div class="flex justify-between px-4 py-5 mt-0" (click)="$event.stopPropagation()">
      @if (!!hasGuardianAccess) {
        <div class="rounded-lg border-dashed border border-[#7e9bd4] h-[162px] w-[134px]">
          @if (user$ | async; as user) {
            <div class="user__profile--info--wrapper h-full m-0 relative">
              <input
                type="file"
                class="hidden w-full h-full"
                #fileUpload
                (change)="fileChangeEvent($event)"
                id="fileUpload"
                name="fileUpload"
                accept="image/png,  image/jpeg"
                />
                <!-- <div
                class="user__profile--image--wrapper h-full items-center"
                *ngIf="user?.profile_image_url; else initialLoader"
                (click)="fileUpload.click()"
                > -->
                <div class="user__profile--image--wrapper h-full items-center" (click)="fileUpload.click()">
                  <span>
                    <!-- (click)="fileUpload.click()" -->
                    <img class="user__profile--edit--image" src="/assets/images/change-profile.svg" />
                  </span>
                  <img
                    class="user__profile--image w-20 h-20"
                    [src]="pendingImgSrc ? pendingImgSrc : '/assets/images/admin-light-grey.png'"
                    name="{{ user?.first_middle_name + ' ' + user?.last_name | titlecase }}"
                    />
                  </div>
                  <ng-template #initialLoader>
                    @if (user.first_middle_name || user.last_name) {
                      <div class="user__profile--image--wrapper">
                        <span (click)="fileUpload.click()">
                          <img class="user__profile--edit--image" src="/assets/images/change-profile.svg" />
                        </span>
                        <ngx-avatars
                          size="112"
                          [src]=""
                          name="{{ user?.first_middle_name + ' ' + user?.last_name | titlecase }}"
                          [round]="true"
                          initialsSize="2"
                        ></ngx-avatars>
                      </div>
                    } @else {
                      <ng-template [ngTemplateOutlet]="showinitialLoader"></ng-template>
                    }
                  </ng-template>
                </div>
              } @else {
                <div class="ph-item sm:items-center h-full p-0 border-0">
                  <div class="ph-col-12 m-auto">
                    <div class="ph-avatar flex fl-al-center w-[85px] h-[85px] m-0 mx-auto"></div>
                  </div>
                </div>
              }
            </div>
          }
          <div [class]="!hasGuardianAccess ? 'w-full' : 'w-[65%]'">
            <form class="w-full" [formGroup]="connectionForm">
              <mat-form-field
                appearance="fill"
                style="width: 100% !important; max-width: 100%"
                class="connection_form automtic-form-desing-form-only add-automtic-form-desing"
                >
                <mat-label class="automtic-form-desing-lable"> {{ !hasGuardianAccess ? 'Full' : 'First' }} Name </mat-label>
                <input
                  matInput
                  [placeholder]="!hasGuardianAccess ? 'Full Name' : 'First Name'"
                  type="text"
                  [formControlName]="!hasGuardianAccess ? 'full_name' : 'first_name'"
                  required
                  (keydown)="handleTabFix($event)"
                  />
                </mat-form-field>
                <mat-form-field
                  appearance="fill"
                  style="width: 100% !important"
                  class="connection_form automtic-form-desing-form-only add-automtic-form-desing full-width"
                  >
                  <mat-label class="automtic-form-desing-lable">{{ !hasGuardianAccess ? 'Email' : 'Last Name ' }}</mat-label>
                  <input
                    matInput
                    [placeholder]="!hasGuardianAccess ? 'Email' : 'Last Name'"
                    type="text"
                    [formControlName]="!hasGuardianAccess ? 'email' : 'last_name'"
                    required
                    (keydown)="handleTabFix($event)"
                    />
                  </mat-form-field>
                  <div>
                    <connect-relationship-dialog
                      #connectRelationshipDialog
                      [hideText]="true"
                      (onDatePicked)="doSomething($event)"
                      [fromInvite]="true"
                      [data]="connection_relationship_data"
                      [isGuardian]="false"
                      [selectedRelationship]="selectedRelationship"
                      [subMemberPlaceHolder]="'Their relationship to you'"
                      [isConnectionModalBtn]="true"
                      (relationshipId)="relationshipIdChanged($event)"
                      >
                    </connect-relationship-dialog>
                  </div>
                </form>
              </div>
            </div>
            <div class="flex w-full justify-end bg-[#ebf0fa] p-4 absolute bottom-0">
              <button
        [class]="
          connectionForm.valid && connectionForm.controls['relationship_type'].value
            ? 'app__btn--primary rounded-md w-24 h-7 flex items-center justify-center m-0 p-0 text-sm'
            : 'app__btn--disabled rounded-md w-24 h-7 flex items-center justify-center m-0 p-0 text-sm'
        "
                (click)="$event.stopPropagation(); connectionForm.valid && connectionForm.controls['relationship_type'].value ? submitForm() : ''"
                >
                Add
              </button>
            </div>
          </div>
        </mat-menu>

